import { useDispatch, useSelector } from "react-redux";
import { Avatar, Grid,Group,Indicator, Tooltip, createStyles} from '@mantine/core';


const useStyles = createStyles((theme) => ({
  padtop10: {
    paddingTop: `10px`,
  },

  margright: {
    marginRight: '5px',
  },
  guestrow: {
    backgroundColor: "#fcfcfc",
    padding: "5px",
    paddingTop: "10px",
    paddingRight: "15px",
    borderLeft: `1px dotted #868e96`,
  },
  gast: {
    display: 'inline-block', /* Allow for rotation */
    textAlign: 'center',
    transform: 'rotate(90deg)',
    paddingRight: "20px",
  },
  
}));





export function ShowUserForMeeting() {
  const { classes } = useStyles();
    const initparticipants = useSelector((state: any) => state.user.guest_meeting_participants)
   
    const notardata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return obj.role === "notar" 
    });

    const notarrows = (notardata || []).map((item:any, index:any) => {

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName 

 

       let inmeetingcolor = "gray"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "gray"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "gray"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
        <Tooltip label={fullname}>
          <span className={classes.margright}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={fullname} variant="outline" color={inmeetingcolor}   radius="xl" size="md" >
             {initialen} 
          </Avatar> 
      </Indicator>
      </span>
      </Tooltip>
       )
    })

    const userdata = initparticipants.filter((obj: { role: any; meetingParticipantStatus: string; }) => {
        return obj.role === "user" 
    });

    const userrows = (userdata || []).map((item:any, index:any) => {

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName

       let inmeetingcolor = "gray"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "gray"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "gray"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
        <Tooltip label={fullname}>
          <span className={classes.margright}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={fullname} variant="outline" color={inmeetingcolor}   radius="xl" size="md" >
             {initialen} 
          </Avatar> 
      </Indicator>
      </span>
      </Tooltip>
       )
    })


    const guestdata = initparticipants.filter((obj: {isBlocked: any; role: any; meetingParticipantStatus: string; }) => {
        //console.log(obj.isBlocked)
        return obj.role === "gast" && !obj.isBlocked 
    });

    const guestrows = (guestdata || []).map((item:any, index:any) => {

       /* let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b
        let fullname = item.lastName + " " + item.firstName */
        const [username, domain] = item.emailAddress.split('@')[0]
        const initials = username[0].toUpperCase() + domain[0].toUpperCase();

        

      

        let initialen = "GU"
        let fullname = item.emailAddress

       let inmeetingcolor = "gray"
       if (item.meetingParticipantStatus === null) {
         inmeetingcolor = "gray"
       }
       if (item.meetingParticipantStatus === "LeftMeeting") {
         inmeetingcolor = "gray"
       }
       if (item.meetingParticipantStatus === "InMeeting") {
         inmeetingcolor = "green"
       }

       return (
       
      <span className={classes.margright}>
        <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
           <Avatar  alt={initials} variant="outline" color={inmeetingcolor}   radius="xl" size="md" >
             {initials} 
          </Avatar> 
      </Indicator>
      </span>
    
       )
    })

   

   

 

  

  return (
    <>
    <Grid className={classes.padtop10}>
    <Grid.Col xs={12} sm={12} md={12} >
    <Group spacing="xs">
          {notarrows} 
          {userrows}  
          {guestrows.length !== 0 &&
          <div className={classes.guestrow}>
            <div className={classes.gast}>Gast</div>
            {guestrows}</div>
          }
        </Group>
      </Grid.Col>
  
         
    
    </Grid>
    </>
  );
}